import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#6B7280",
    },
    background: {
      default: "#FFFFFF",
      paper: "white",
    },
    text: {
      primary: "#a5a5a5",
      secondary: "#a5a5a5",
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: "2rem",
      fontWeight: 600,
      color: "#a5a5a5",
    },
    h2: {
      fontSize: "1.5rem",
      fontWeight: 600,
      color: "#a5a5a5",
    },
    h3: {
      fontSize: "1.25rem",
      fontWeight: 600,
      color: "#a5a5a5",
    },
    h4: {
      fontSize: "1.125rem",
      fontWeight: 600,
      color: "#a5a5a5",
    },
    h5: {
      fontSize: "1rem",
      fontWeight: 600,
      color: "#a5a5a5",
    },
    h6: {
      fontSize: "0.875rem",
      fontWeight: 600,
      color: "#a5a5a5",
    },
    subtitle1: {
      fontSize: "1rem",
      fontWeight: 500,
      color: "#a5a5a5",
    },
    subtitle2: {
      fontSize: "0.875rem",
      fontWeight: 400,
      color: "#333333",
    },
    body1: {
      fontSize: "1rem",
      fontWeight: 400,
      color: "#a5a5a5",
    },
    body2: {
      fontSize: 13,
      fontWeight: 300,
      color: "#a5a5a5",
    },
    button: {
      fontSize: "0.875rem",
      fontWeight: 500,
      textTransform: "none",
    },
    caption: {
      fontSize: "0.75rem",
      fontWeight: 400,
      color: "#a5a5a5",
      lineHeight: "0.8rem",
    },
    caption1: {
      fontSize: 11,
      fontWeight: 300,
      color: "#a5a5a5",
    },
    overline: {
      fontSize: "0.75rem",
      fontWeight: 600,
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      color: "#a5a5a5",
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff",
          display: "flex",
          alignItmes: "center",
          outline: 0,
          color: "#333333",
          "& .MuiOutlinedInput-root": {
            backgroundColor: "#ffffff",
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#00246a",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#123a8b",
              borderWidth: 1,
            },
          },
          "& .MuiOutlinedInput-input": {
            padding: "10px 14px",
            height: "24px",
            fontSize: "1rem",
            "&::placeholder": {
              color: "#9CA3AF",
              opacity: 0.8,
              fontSize: 12,
            },
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#E5E7EB",
          },
          "& .MuiInputLabel-outlined": {
            color: "#6B7280",
            fontSize: "0.875rem",
            fontWeight: 500,
            transform: "translate(14px, -6px) scale(0.75)",
            "&.Mui-focused": {
              color: "#6B7280",
            },
          },

          "& input::-webkit-calendar-picker-indicator": {
            marginTop: "-20px",
          },
          '& input[type="date"]::-webkit-input-placeholder': {
            visibility: "hidden ",
            display: "block",
          },
          "&::placeholder": {
            opacity: 0.8,
            fontStyle: "Manrope",
            fontSize: 12,
          },

          '& input[type="date"]::-webkit-calendar-picker-indicator': {
            marginTop: "5px",
          },
          // '& input[type="date"]::-webkit-input-placeholder': {
          //   visibility: "hidden !important",
          // },
          '& input[type="date"]::before': { content: "none" },
        },
      },
      defaultProps: {
        variant: "outlined",
        fullWidth: true,
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#f8f8f7",
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#E5E7EB",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#123a8b",
            borderWidth: 1,
          },
          "&::placeholder": {
            opacity: 0.8,
            fontStyle: "Manrope",
            color: "gray",
            fontSize: 12,
          },
        },
        input: {
          padding: "10px 14px",
        },
        notchedOutline: {
          borderColor: "#123a8b",
        },
      },
    },
    // MuiInputLabel: {
    //   styleOverrides: {
    //     root: {
    //       color: "#a5a5a5",
    //       fontSize: "1rem",
    //       fontWeight: 300,
    //       "&.Mui-focused": {
    //         color: "#123a8b",
    //       },
    //       transform: "translate(14px, -8px) scale(0.75)",
    //       "&::placeholder": {
    //         opacity: 0.8,
    //         fontStyle: "Manrope",
    //         fontSize: 12,
    //       },
    //     },
    //   },
    // },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
          fontWeight: 500,
          color: "#6B7280",
          "&::placeholder": {
            opacity: 0.8,
            fontStyle: "Manrope",
            fontSize: 12,
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          color: "#9CA3AF",
        },
        root: {
          backgroundColor: "white",
          "&::placeholder": {
            opacity: 0.8,
            fontStyle: "Manrope",
            fontSize: 12,
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: "#D1D5DB",
          fontSize: 12,
          "&.Mui-checked": {
            color: "#123a8b",
          },
          "&::placeholder": {
            opacity: 0.8,
            fontStyle: "Manrope",
            fontSize: 12,
            backgroundColor: "transparent",
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          //   width: 42,
          //   height: 26,
          //   padding: 0,
          //   margin: 8,
          "&::placeholder": {
            opacity: 0.8,
            fontStyle: "Manrope",
            fontSize: 12,
          },
        },
        switchBase: {
          //   padding: 1,
          "&.Mui-checked": {
            transform: "translateX(16px)",
            color: "#fff",
            "& + .MuiSwitch-track": {
              backgroundColor: "#123a8b",
              opacity: 1,
              border: 0,
            },
          },
          "&.Mui-focusVisible .MuiSwitch-thumb": {
            color: "#3B82F6",
            border: "6px solid #fff",
          },
        },
        thumb: {
          width: 24,
          height: 24,
        },
        track: {
          borderRadius: 13,
          border: "1px solid #E5E7EB",
          backgroundColor: "#E5E7EB",
          opacity: 1,
          transition: "background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: "#00246a",
          color: "white",
          "&:hover": {
            backgroundColor: "#001c54",
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          margin: 0,
          width: "50%",
        },
        label: {
          width: "100%",
          textAlign: "center",
          padding: "8px 0",
          borderRadius: "4px",
          transition: "background-color 0.3s, color 0.3s",
          fontSize: 12,
          "&:hover": {
            backgroundColor: "#f0f0f0",
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          // color: "white",
          transformOrigin: "top left",
          whiteSpace: " nowrap",
          overFlow: "hidden",
          textOverflow: "ellipsis ",
          // maxWidth: " calc(133%-32px) ",
          position: " absolute ",
          top: 0,
          left: " 0 ",
          transform: "translate(14px, -9px) scale(0.75) ",
          transition:
            "color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, max-width 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
          zIndex: 1,
          pointerEvents: "auto",
          backgroundColor: "white",
          padding: "0 10px",
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#D1D5DB",
          fontSize: 12,
          "&.Mui-checked": {
            color: "#123a8b",
          },
          "&::placeholder": {
            opacity: 0.8,
            fontStyle: "Manrope",
            fontSize: 12,
            backgroundColor: "transparent",
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        "*::-webkit-input-placeholder": {
          opacity: 0.8,
          fontStyle: "Manrope",
        },
        "*::-moz-placeholder": {
          opacity: 0.8,
          fontStyle: "Manrope",
        },
        "*:-ms-input-placeholder": {
          opacity: 0.8,
          fontStyle: "Manrope",
        },
      },
    },
  },
});

export default theme;
